/**
 * Returns a function that removes the keys with null or undefined value from the object that receives as argument
 *
 * Sample of usage:
 *
 * ```js
 * let data = {
 *      name: "EMF Amps Loading",
 *      alias: "emf_Amps",
 *      config: {
 *          label: "Amps",
 *          roundDecimals: null
 *      }
 * };
 *
 * const response = deleteEmptyKeys('config')(data);
 *
 * console.log(response);
 *
 * {
 *     name: "EMF Amps Loading",
 *     alias: "emf_Amps",
 *     config: {
 *         label: "Amps"
 *     }
 * };
 * ```
 *
 * @param  {...any} keys
 * @returns function that removes the keys with null or undefined value from the object that receives as argument
 */

function deleteEmptyKeys(...keys) {
    function _deleteEmptyKeys(obj) {
        for (let key in obj) {
            if ([undefined, null].includes(obj[key])) {
                delete obj[key];
            } else if (typeof obj[key] === "object") {
                _deleteEmptyKeys(obj[key]);
            }
        }

        return obj;
    }

    return (params) => {
        for (let key of keys) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                params[key] = _deleteEmptyKeys(params[key]);
            }
        }

        return params;
    };
}

export { deleteEmptyKeys };
